/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { capitalizeText } from '@global/helpers';
import PropTypes from 'prop-types';

const propTypes = {
  status: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const defaultProps = {
  status: '',
  type: 'normal',
  style: {},
};

const ProductBadge = (props) => {
  const { status = '', type = 'normal', style = {} } = props;

  let label = '';
  let statusBackground = '#E5E5E525';
  if (status == 'best') {
    statusBackground = '#3DE96625';
  } else if (status == 'promo') {
    statusBackground = '#1E68FC25';
  } else if (status == 'new') {
    statusBackground = '#ffd02826';
  }

  if (status) {
    try {
      label = status.replace(/_/g, ' ');
    } catch (error) {}
  }

  return (
    <View
      style={[
        styles.statusWrapper,
        { backgroundColor: statusBackground },
        type == 'mini' ? styles.statusMini : {},
        style,
      ]}>
      <SociollaText
        style={{ fontSize: 11, color: Colors.black, letterSpacing: 0.5 }}>
        {capitalizeText(label)}
      </SociollaText>
    </View>
  );
};

const styles = StyleSheet.create({
  statusWrapper: {
    position: isWeb ? 'inherit' : 'relative',
    paddingVertical: 6,
    paddingHorizontal: 14,
    borderRadius: 4,
    alignItems: 'center',
  },
  statusMini: { paddingHorizontal: 7, paddingVertical: 3 },
});

ProductBadge.propTypes = propTypes;
ProductBadge.defaultProps = defaultProps;

export default ProductBadge;
